'use client';

import { getENV } from '../../utils/env';
import { useConsentGatedInit } from '../hooks/useConsentGatedInit';

export const AdyenDataCollectionV2 = () => {
    useConsentGatedInit({
        src: getENV('NEXT_PUBLIC_ADYEN_DATA_COLLECTION_SDK_SCRIPT_URL'),
        consentGroup: 'C0001',
    });

    return null;
};
